import styled from '@emotion/styled';
import { useState } from 'react';
import InfoTab from 'components/InfoTab';
import PropTypes from 'prop-types';

const Container = styled.section`
  width: 100%;
`;

const InfoTabs = ({ faqTabs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <Container>
      {faqTabs.map((faqTab, index) => (
        <InfoTab
          key={index}
          content={faqTab}
          isOpen={openIndex === index}
          onToggle={() => handleToggle(index)}
        />
      ))}
    </Container>
  );
};

InfoTabs.propTypes = {
  faqTabs: PropTypes.array.isRequired,
};

export default InfoTabs;
